import BffApiResponse from '../models/BffApiResponse';
import api from '../utils/axios';
import { formattingTitaskBffResponseErrors } from '../utils/utils';

const NotificationService = {
  getCountUnread: async (): Promise<BffApiResponse> => {
    try {
      const response = await api.get(`/user-notification/count-unread`);
      return new BffApiResponse<GetCountUnreadNotificationSchema>(
        true,
        response.data.data
      );
    } catch (err) {
      return formattingTitaskBffResponseErrors(err);
    }
  },
  getAllByCurrentUser: async (
    page: number,
    pageSize: number
  ): Promise<BffApiResponse> => {
    try {
      const response = await api.post(
        `/user-notification/get-by-current-user`,
        { page, pageSize }
      );
      return new BffApiResponse<GetAllNotificationsByCurrenUserSchema>(
        true,
        response.data.data
      );
    } catch (err) {
      return formattingTitaskBffResponseErrors(err);
    }
  },
  markAsRead: async (notificationId: string): Promise<BffApiResponse> => {
    try {
      const response = await api.put(
        `/user-notification/mark-as-read/${notificationId}`
      );
      return new BffApiResponse<{ executedAction: boolean }>(
        true,
        response.data.data
      );
    } catch (err) {
      return formattingTitaskBffResponseErrors(err);
    }
  },
  markAllAsRead: async (): Promise<BffApiResponse> => {
    try {
      const response = await api.put(`/user-notification/mark-all-as-read`);
      return new BffApiResponse<{ executedAction: boolean }>(
        true,
        response.data.data
      );
    } catch (err) {
      return formattingTitaskBffResponseErrors(err);
    }
  },
};

export default NotificationService;

export interface GetCountUnreadNotificationSchema {
  count: number;
}

export interface GetAllNotificationsByCurrenUserSchema {
  data: Notification[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface Notification {
  id: string;
  userId: number;
  title: string;
  body: string;
  imageS3Key: string | null;
  type: 'INFO' | 'WARNING' | 'ERROR' | 'REMINDER';
  channel: string;
  actionUrl: string | null;
  metadata: Record<string, any>;
  isRead: boolean;
  readAt: Date | null;
  readBy: number | null;
  createdAt: Date;
  createdBy: number | null;
  isNew?: boolean; // Controls chip visibility for WebSocket new messages
}
